export const EDITING_ENDED = 'EDITING_ENDED';

export const editingEnded = () => ({
  type: EDITING_ENDED
});

export type EditingEndedAction = ReturnType<typeof editingEnded>;
